"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainWrapper = exports.Wrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../themes/colors");
exports.Wrapper = styled_components_1.default.div `
  ${({ showChain }) => (0, styled_components_1.css) `
    background-color: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 3px;
    width: fit-content;
    position: ${showChain ? 'relative' : 'unset'}};

    & > img {
      border-radius: 50%;
      object-fit: contain;
      overflow: hidden;
    }
  `}
`;
exports.ChainWrapper = styled_components_1.default.div `
  box-sizing: border-box;
  border-radius: 50%;
  background-color: ${colors_1.colors.shade10};
  position: absolute;
  bottom: -3px;
  right: 5px;
  padding: 2px;
  display: flex;
  align-self: flex-end;
  margin-right: -10px;
  object-fit: contain;
  width: fit-content;
  overflow: hidden;
`;
//# sourceMappingURL=styled.js.map